<template>
  <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

    <b-form @submit.prevent="save">
      <b-card no-body>
        <b-card-body>
          <b-row>

            <lg-form-input invalidFeedback=" " description="" v-model="form.id" label="Código:" sm="2" disabled />
          </b-row>
          <b-row>

            <lg-form-input invalidFeedback=" " description=" " v-model="form.dataAtual" label="Data:*" md="2" sm="2"
              cols="2" disabled />

            <lg-form-date invalidFeedback="A data deve ser informada!" description="" v-model="form.dataAgendamento"
              typeDatepicker="date" label="Agendamento:" sm="4" cols="4" />

          </b-row>

          <b-row>

            <lg-form-input invalidFeedback="Este campo não pode ser vazio!" description=" " v-model="form.descricao"
              :error="$v.form.descricao" label="Descrição:*" md="12" sm="12" cols="2" />

          </b-row>

          <b-row>


            <b-col md="7">
              <b-form-group style="margin-left: 16px" v-if="podeMovimentarDireto()">
                <b-form-checkbox @change="mudarMovimentacao" v-model="movimentacaoDireta" id="checkbox-2">
                  <template #default>
                    <p style="font-size: 13px; margin-top: 2px">
                      Movimentação direta
                    </p>
                  </template>
                </b-form-checkbox>
              </b-form-group>
              <b-row>
                <b-col md="7">
                  <div style="margin-top: -14px">
                    <p style="font-size: 13px; margin-top: 2px">
                      Replicar unidade administrativa destino
                    </p>
                  </div>
                </b-col>
                <b-col md="5">
                  <div style="margin-top: -4px; margin-left: -70px">
                    <lg-finder-page-unidade-administrativa v-model="form.unidadeAdministrativa"
                      :prefix="prefix + title + ' > '" id="finderDepartamentoSolicitanteFormSolicitacao"
                      @onselect="unidadeAdministrativaSelect" label="">
                    </lg-finder-page-unidade-administrativa>

                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="7">
                  <div style="margin-top: -14px">
                    <p style="font-size: 13px; margin-top: 2px">
                      Replicar localização física destino
                    </p>
                  </div>
                </b-col>
                <b-col md="5">
                  <div style="margin-top: -4px; margin-left: -70px">
                    <lg-finder-page-local-armazenamento :prefix="prefix + title + ' > '"
                      :departamento="form.unidadeAdministrativaReplica" v-model="form.localArmazenamento"
                      @input="localArmazenamentoSelect"
                      :podeMudar="movimentacaoDireta && form.unidadeAdministrativaReplica.id > 0"
                      id="finderPageLocalArmazenamento" label="" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="7">
                  <div style="margin-top: -14px">
                    <p style="font-size: 13px; margin-top: 2px">
                      Replicar usúario solicitante
                    </p>
                  </div>
                </b-col>
                <b-col md="5">
                  <div style="margin-top: -4px; margin-left: -70px">
                    <lg-finder-page-pessoa id="finderUsuarioSolicitaao" @onselect="usuarioSelect"
                      invalidFeedback="Usuário deve ser informado!" :prefix="prefix + title + ' > '" description=""
                      v-model="form.usuario" label="">
                    </lg-finder-page-pessoa>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="5">
              <figure>
                <img :src="imageAlert" alt="" width="93%" style="margin-top: 30px;" />
              </figure>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="text-right">
              <b-button id="novoSolicitacaoForm" class="ml-3 mr-2 my-2" style="height: 20px" @click="mostrarModal"
                size="sm" pill variant="success">
                <div class="btn-size-alinhamento">
                  <b-icon scale="1" icon="plus" />
                </div>
                <b-tooltip target="novoSolicitacaoForm" title="Adicionar novo..."></b-tooltip>
              </b-button>

            </b-col>
          </b-row>

          <b-card bg-variant="light" class="mt-2">
            <b-table responsive :busy="this.busy" :items="form.itens" :fields="this.tableFields" show-empty>
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <p>Selecione algum Item Bem Permanente</p>
              </template>

              <template v-slot:cell(remover)="{ item }">
                <b-button :id="'remover' + item.itemBemPermanente.id" size="sm" variant="danger"
                  @click="removerItem(item)">
                  <b-icon icon="trash" />
                  <b-tooltip :target="'remover' + item.itemBemPermanente.id"
                    title="Remover item da Solicitação..."></b-tooltip>
                </b-button>
              </template>

              <template v-slot:cell(usuarioSolicitante)="row">

                <lg-finder-page-pessoa class="mt-4" :id="'finderUsuarioSolicitaao' + row.item.itemBemPermanente.id"
                  @onselect="function (usuario) { row.item.usuarioSolicitante = usuario; }" invalidFeedback=" "
                  :prefix="prefix + title + ' > '" description="" v-model="row.item.usuarioSolicitante" label="">
                </lg-finder-page-pessoa>

              </template>

              <template v-slot:cell(departamentoDestino)="row">

                <lg-finder-page-unidade-administrativa class="mt-4" v-model="row.item.departamentoDestino"
                  :prefix="prefix + title + ' > '"
                  :id="'finderDepartamentoSolicitanteFormSolicitacao' + row.item.itemBemPermanente.id"
                  @onselect="function (departamentoDestino) { row.item.departamentoDestino = departamentoDestino; row.item.localArmazenamentoAprovacaoEntrega = {} }"
                  label=" ">
                </lg-finder-page-unidade-administrativa>

              </template>
              <template v-slot:cell(localArmazenamentoAprovacaoEntrega)="row">

                <lg-finder-page-local-armazenamento class="mt-4" :prefix="prefix + title + ' > '"
                  :departamento="row.item.departamentoDestino" v-model="row.item.localArmazenamentoAprovacaoEntrega"
                  @input="function (localArmazenamentoAprovacaoEntrega) { row.item.localArmazenamentoAprovacaoEntrega = localArmazenamentoAprovacaoEntrega }"
                  :podeMudar="movimentacaoDireta && row.item.departamentoDestino.id > 0"
                  :id="'finderPageLocalArmazenamento' + row.item.itemBemPermanente.id" label=" " />

              </template>
            </b-table>

          </b-card>
          <b-row>
            <b-col cols="12" class="d-flex justify-content-end" style="margin-left: -20px">
              Itens selecionados: {{ form.itens.length }}
            </b-col></b-row>
          <b-form-row>

            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
              <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success" @click="save">
                <b-icon icon="check-circle" />
                <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

              </b-button>
              <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
                <b-icon icon="x-circle" />
                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

              </b-button>

            </b-col>
            <b-col cols="3"></b-col>

          </b-form-row>
        </b-card-body>
      </b-card>
    </b-form>
    <ModalPageItemBemPermanente :prefix="prefix + title + ' > '" @onselect="selecionarItem" @cancelar="fecharModal"
      v-if="showModalPage" :podeMudarDepartamento="false">
    </ModalPageItemBemPermanente>

  </b-modal>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import ModalPageItemBemPermanente from "@/core/components/Modals/ModalPageItemBemPermanente.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";

import ResourceService from "@/core/api/ResourceService";
import { required } from "vuelidate/lib/validators";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import { isoDate } from "../../almoxarifados/registros-entrada/utils/isoData";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";

import imageAlert from "./alert-image.png";

export default {
  components: {
    LgFormDate,
    LgFormInput,
    ModalPageItemBemPermanente,
    LgFinderPageLocalArmazenamento,
    LgFinderPageUnidadeAdministrativa,
    LgFinderPagePessoa,

  },
  mixins: [ListResourceMixin, FormResourceMixin],

  props: {
    id: Number,
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Cadastro",
    }

  },

  async beforeMount() {
    this.$service = new ResourceService(`/api/solicitacaomovimentacao`);
    this.$itemService = new ResourceService(`/api/itembempermanente`);

    this.brand = JSON.parse(localStorage.getItem("context"));

    this.form.departamento = this.brand.departamento;
    this.form.pessoa = this.brand.usuario;

    
    if(this.id && this.id > 0){
      var {data} =  await this.$service.findById(this.id);

      this.form = data;
      this.form.itenRemoverList = [];
      
    }


  },
  data() {
    return {
      busy: false,
      showModal: true,
      showModalPage: false,
      imageAlert,
      movimentacaoDireta: false,
      form: {
        itenRemoverList: [],
        unidadeAdministrativaReplica: {},
        dataAgendamento: "",
        usuario: {},
        localArmazenamento: {},
        dataAtual: this.formatDate(isoDate()),
        unidadeAdministrativa: {},
        itens: []
      },
    };
  },
  name: "SolicitacaoMovimentacaoForm",
  validations: {
    form: {
      descricao: {
        required,
      },
    },
  },
  computed: {
    formIsValid() {
      return !this.$v.$invalid;
    },
    tableFields() {
      return [
        { key: "itemBemPermanente.numTombamento", label: "Nº Tombamento" },
        { key: "itemBemPermanente.itemRegEntrada.produto.numero", label: "Número" },
        {
          key: "itemBemPermanente.itemRegEntrada.produto.descricaoResumida",
          label: "Descrição",
        },
        { key: "departamentoOrigem.descricao", label: "Origem" },
        { key: "departamentoDestino", label: "UA departamentoDestino", class: "w-20" },
        { key: "localArmazenamentoAprovacaoEntrega", label: "Local departamentoDestino", class: "w-20" },
        {
          key: "usuarioSolicitante",
          label: "Usuario Solicitante",
          class: "w-20",
        },
        { key: "remover", label: " ", class: "w-20" },


      ];
    },
  },
  methods: {
    removerItem(item) {
      if (item.id && item.id > 0) {
        this.form.itenRemoverList.push(item.id);
      }

      this.form.itens.splice(
        this.form.itens.indexOf(item),
        1
      );

    },
    mudarMovimentacao(valor) {
      if (!valor) {
        this.form.localArmazenamento = {};
        this.form.itens.forEach(item => {
          item.localArmazenamentoAprovacaoEntrega = {};
        })
      }
    },
    podeMovimentarDireto() {
      return !this.id && this.temPrivilegioGerenciarParecerSolicitacaoMovimentacao()
    },

    temPrivilegioGerenciarParecerSolicitacaoMovimentacao() {
      return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PARECER_SOLICITACAO_MOVIMENTACAO);

    },

    formatDate(dateString) {
      const date = new Date(dateString);

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    async selecionarItem(itemSelecionado) {


      const found = this.form.itens.find(
        item => item.itemBemPermanente.id === itemSelecionado.id
      );

      if (found) {
        this.$notify({
          type: "danger",
          message: "Item Bem Permanente já vinculado!",
        });
        return;
      }

      this.form.itens.push({ itemBemPermanente: {id: itemSelecionado.id, numTombamento:itemSelecionado.numTombamento, itemRegEntrada:{produto: {numero:itemSelecionado.numero, descricaoResumida: itemSelecionado.descricaoResumida}}}, departamentoOrigem: this.form.departamento, departamentoDestino: {}, localArmazenamentoAprovacaoEntrega: {}, usuarioSolicitante: {} });

      this.fecharModal();


    },
    usuarioSelect(usuario) {
      this.form.usuarioSelect = usuario;
      this.form.itens.forEach(item => {
        item.usuarioSolicitante = usuario;
      })

    },
    unidadeAdministrativaSelect(departamentoDestino) {
      this.form.unidadeAdministrativaReplica = departamentoDestino;

      this.form.itens.forEach(item => {
        item.departamentoDestino = departamentoDestino;
        item.localArmazenamentoAprovacaoEntrega = {};
      });
    },
    localArmazenamentoSelect(localArmazenamentoAprovacaoEntrega) {
      this.form.localArmazenamento = localArmazenamentoAprovacaoEntrega;

      this.form.itens.forEach(item => {
        item.localArmazenamentoAprovacaoEntrega = localArmazenamentoAprovacaoEntrega;
      });

    },
    fecharModal() {
      this.showModalPage = false;
    },
    cancelar() {
      this.$emit("close");
    },
    mostrarModal() {
      this.showModalPage = true;
    },

    async save() {

      if (this.form.itens.length == 0) {
        this.$notify({
          type: "danger",
          message: `Selecione um Item Bem Permanente para a movimentação`,
        });
        return;
      }

      if (this.form.descricao == "" || this.form.itens.some(item => !(item.departamentoDestino && item.departamentoDestino.id > 0) || !(item.usuarioSolicitante && item.usuarioSolicitante.id > 0))) {
        this.$notify({
          type: "danger",
          message: `Preencha os campos corretamente`,
        });
        return;
      }

      this.form.movimentacaoDireta = this.movimentacaoDireta;
      if (this.movimentacaoDireta) {

        this.busy = true;
        await this.$service.post(`movimentar`, this.form);
        this.busy = false
        this.$notify({
          type: "success",
          message: `Registro salvo com sucesso`,
        });

      } else {

        this.busy = true;
        await this.$saveResource(this.form, "", false, {}, false, true);
        this.busy = false;
      }

      this.cancelar();
    },

  },
};
</script>
